import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { useSite } from '../context/SiteContext';
import { FrontEndRoutes } from '../config/front-end-routes';

const Footer: React.FC = () => {
  const { config, serviceGroups, whatsappUrl } = useSite();

  return (
    <footer className="bg-profile-1 text-white pt-5 pb-4">
      <Container>
        <Row className="g-4 mb-4">
          <Col md={3}>
            <h5 className="fw-bold mb-4 text-profile-3">{config?.site_title || 'Clínica'}</h5>
            {config?.site_description && <p className="text-white-50 mb-4">{config.site_description}</p>}
            <div className="d-flex gap-3">
              {config?.facebook_url && <a href={config.facebook_url} className="text-white-50 hover-text-profile-3" target="_blank" rel="noopener noreferrer"><i className="fab fa-facebook-f"></i></a>}
              {config?.instagram_url && <a href={config.instagram_url} className="text-white-50 hover-text-profile-3" target="_blank" rel="noopener noreferrer"><i className="fab fa-instagram"></i></a>}
              <a href={whatsappUrl} className="text-white-50 hover-text-profile-3" target="_blank" rel="noopener noreferrer"><i className="fab fa-whatsapp"></i></a>
              {config?.linkedin_url && <a href={config.linkedin_url} className="text-white-50 hover-text-profile-3" target="_blank" rel="noopener noreferrer"><i className="fab fa-linkedin-in"></i></a>}
            </div>
          </Col>

          {serviceGroups.length > 0 && (
            <Col md={2}>
              <h6 className="fw-bold mb-3">Serviços</h6>
              <ul className="list-unstyled">
                {serviceGroups.slice(0, 5).map(g => (
                  <li className="mb-2" key={g.id}>
                    <Link to={FrontEndRoutes.SERVICES} className="text-white-50 text-decoration-none hover-text-profile-3">{g.description}</Link>
                  </li>
                ))}
              </ul>
            </Col>
          )}

          <Col md={2}>
            <h6 className="fw-bold mb-3">Links Rápidos</h6>
            <ul className="list-unstyled">
              <li className="mb-2"><Link to={FrontEndRoutes.HOME} className="text-white-50 text-decoration-none hover-text-profile-3">Início</Link></li>
              {config?.show_services !== false && <li className="mb-2"><Link to={FrontEndRoutes.SERVICES} className="text-white-50 text-decoration-none hover-text-profile-3">Serviços</Link></li>}
              {config?.show_team !== false && <li className="mb-2"><Link to={FrontEndRoutes.TEAM} className="text-white-50 text-decoration-none hover-text-profile-3">Equipe</Link></li>}
              {config?.show_about !== false && <li className="mb-2"><Link to={FrontEndRoutes.ABOUT} className="text-white-50 text-decoration-none hover-text-profile-3">Sobre</Link></li>}
              {config?.show_contact !== false && <li className="mb-2"><Link to={FrontEndRoutes.CONTACT} className="text-white-50 text-decoration-none hover-text-profile-3">Contato</Link></li>}
            </ul>
          </Col>

          <Col md={5}>
            <h6 className="fw-bold mb-3">Contato</h6>
            <address className="text-white-50">
              {config?.address && (
                <p className="mb-2">
                  <i className="fas fa-map-marker-alt me-2 text-profile-3"></i>
                  <a href={`https://maps.google.com/?q=${encodeURIComponent(config.address)}`} className="text-white-50 text-decoration-none hover-text-profile-3" target="_blank" rel="noopener noreferrer">
                    {config.address}
                  </a>
                </p>
              )}
              {config?.phone && (
                <p className="mb-2">
                  <i className="fas fa-phone-alt me-2 text-profile-3"></i>
                  <a href={`tel:${config.phone.replace(/\D/g, '')}`} className="text-white-50 text-decoration-none hover-text-profile-3">{config.phone}</a>
                </p>
              )}
              {config?.whatsapp && (
                <p className="mb-2">
                  <i className="fab fa-whatsapp me-2 text-profile-3"></i>
                  <a href={whatsappUrl} className="text-white-50 text-decoration-none hover-text-profile-3" target="_blank" rel="noopener noreferrer">{config.whatsapp}</a>
                </p>
              )}
              {config?.email && (
                <p className="mb-2">
                  <i className="fas fa-envelope me-2 text-profile-3"></i>
                  <a href={`mailto:${config.email}`} className="text-white-50 text-decoration-none hover-text-profile-3">{config.email}</a>
                </p>
              )}
            </address>

            {config?.business_hours && config.business_hours.length > 0 && (
              <div className="mt-4">
                <h6 className="fw-bold mb-3">Horário de Funcionamento</h6>
                <div className="text-white-50 small">
                  {config.business_hours.map((h, i) => <p className="mb-1" key={i}>{h.day}: {h.hours}</p>)}
                </div>
              </div>
            )}
          </Col>
        </Row>

        <hr className="border-white-50" />

        <Row className="text-center">
          <Col>
            <p className="text-white-50 mb-0">
              &copy; {new Date().getFullYear()} {config?.site_title}
              {config?.cnpj && <> | CNPJ: {config.cnpj}</>}
              {config?.established_text && <> | {config.established_text}</>}
            </p>
          </Col>
        </Row>
      </Container>

      <style>{`
        .hover-text-profile-3:hover { color: #E0CB8B !important; transition: color 0.3s ease; }
      `}</style>
    </footer>
  );
};

export default Footer;
